import i18n from '../i18n'

const rules = {
  fieldRequired (v) {
    if (v && v.splice) {
      return (v && !!v.length) || i18n.t('El campo es obligatorio')
    }
    return (v && !!v) || i18n.t('El campo es obligatorio')
  },
  min6 (v) { return (v && v.length > 5) || i18n.t('El campo debe de ser mayor de 5 carácteres') },
  email (v) { return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || i18n.t('El email no es válido') },
}
export default rules
